import { syntaxFNMA } from '@aloft/toolkit-shared';
import { toOpts } from '@aloft/toolkit-sui';

import { useMemo } from 'react';

import { PropertyGridSection } from '../../../components/PropertyGrid/columnSections/PropertyGridSection.tsx';
import {
  getAloftPriceJSONPropertyGridField,
  getNumberPropertyGridField,
  suffixField,
} from '../../../components/PropertyGrid/fields/utils.tsx';
import {
  PropertyGridField,
  PropertyGridSectionProps,
} from '../../../components/PropertyGrid/types.ts';

export const FeatureGridTransactionSection = (props: PropertyGridSectionProps) => {
  const fields: PropertyGridField[] = useMemo(
    () => [
      {
        fieldName: 'editableData.transaction.status',
        label: 'Status',
        options: toOpts(['Active', 'Pending', 'Sold']),
        includeEmptyOption: true,
        toValue: (value?: string) => {
          if (!value) return undefined;

          if (value === 'Sold') return 'SettledSale';
          if (value === 'Pending') return 'Contract';

          return value;
        },
        toDisplayValue: (value?: string) => {
          if (!value) return undefined;

          if (value === 'SettledSale') return 'Sold';
          if (value === 'Contract') return 'Pending';

          return value;
        },
      },
      getAloftPriceJSONPropertyGridField({
        fieldName: 'editableData.transaction.price',
        label: 'Price',
        required: true,
        allowExplicitUnknown: true,
      }),
      getAloftPriceJSONPropertyGridField({
        fieldName: 'editableData.transaction.originalListPrice',
        label: 'Orig. List Price',
      }),
      {
        fieldName: 'editableData.transaction.contractDate',
        label: 'Contract Date',
        toDisplayValue: (isoMonth?: string) => {
          if (!isoMonth) return undefined;
          try {
            const date = syntaxFNMA.isoMonthToAloftDate(isoMonth as syntaxFNMA.IsoMonth);
            return date.format('yyyy-MM');
          } catch {
            return isoMonth;
          }
        },
      },
      {
        fieldName: 'editableData.transaction.saleDate',
        label: 'Sale Date',
        required: true,
        allowExplicitUnknown: true,
        toDisplayValue: (isoMonth?: string) => {
          if (!isoMonth) return undefined;
          try {
            const date = syntaxFNMA.isoMonthToAloftDate(isoMonth as syntaxFNMA.IsoMonth);
            return date.format('yyyy-MM');
          } catch {
            return isoMonth;
          }
        },
      },
      suffixField(
        getNumberPropertyGridField({
          fieldName: 'editableData.transaction.daysOnMarket',
          label: 'CDOM',
        }),
        'day',
        'days',
      ),
    ],
    [],
  );

  return <PropertyGridSection {...props} title="Transaction" fields={fields} />;
};
